import LazyLoad from "../../../vendor/assets/javascripts/lazyload";
globalThis.LazyLoad = LazyLoad;
